module.exports = __webpack_public_path__ + "media/images/mailer-survey-request-new-prospect-1d9754931c6ca35b454d3baa88c8893e.png";